import * as Joi from 'joi';

import { Currency } from '../enums/retrieve-transaction.enums';
const MAX_FILE_SIZE_BYTES = 26214400;
const MAX_FILE_SIZE_MB = MAX_FILE_SIZE_BYTES / 1048576;

export const CreateSettlementSchema = Joi.object({
  currencyId: Joi.number()
    .valid(...Object.values(Currency))
    .required()
    .messages({
      'any.only': 'Currency is invalid.',
      'any.required': 'Currency is required.',
      'number.base': 'Currency is invalid.',
    }),
  payoutAmount: Joi.number().max(9999999).required().messages({
    'any.required': 'Payout amount is required.',
    'number.base': 'Payout amount is invalid.',
    'number.max': 'Payout amount is invalid.',
  }),
  transactionDate: Joi.array()
    .items(Joi.date().required())
    .min(2)
    .max(2)
    .required()
    .custom((value, helpers) => {
      if (value[0] === null || value[1] === null) {
        return helpers.message('Transaction date must be a valid date range');
      }
      return value;
    })
    .messages({
      'array.base': 'Transaction date must be an array with two elements.',
      'array.min': 'Transaction date must have at least two elements.',
      'array.max': 'Transaction date must have at most two elements.',
      'any.required': 'Transaction date is required.',
    }),
  merchantId: Joi.number().required().messages({
    'any.only': 'Merchant is invalid.',
    'any.required': 'Merchant is required.',
    'number.base': 'Merchant is invalid.',
  }),
  branchId: Joi.number().required().messages({
    'any.only': 'Branch is invalid.',
    'any.required': 'Branch is required.',
    'number.base': 'Branch is invalid.',
  }),
  soa: Joi.array().min(1).length(1).messages({
    'array.base': 'SOA should be an array.',
    'array.max': 'SOA should contain at most one file.',
    'array.min': 'SOA should contain at least one file.',
    'array.length': 'SOA must contain 1 item.',
    'any.invalid': 'Invalid MIME type.',
  }),
});
